import React, { memo, useMemo } from 'react';

import { DeleteIcon, EditPenIcon } from '@sharedCR/coreDesignSystem/icons';
import { ActionCellButtonCDS } from '@sharedCR/coreDesignSystem/Table/TableCDS/cellContent';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { FeeProviderLocationType } from 'constants/feeProviders';
import { getConditionalArray } from 'utils/data';

const RowActionButton = ({ rowData }) => {
  const { isFormDisabled, type, isLoading, onEdit, onDelete } = rowData;

  const isPrimary = type === FeeProviderLocationType.PRIMARY;

  const items = useMemo(
    () => [
      ...getConditionalArray(!isFormDisabled, [
        {
          text: 'Edit',
          onClick: onEdit,
          icon: <EditPenIcon size={IconSize[20]} />,
        },
      ]),
      ...getConditionalArray(!isFormDisabled && !isPrimary, [
        {
          text: 'Delete',
          onClick: onDelete,
          icon: <DeleteIcon size={IconSize[20]} />,
        },
      ]),
    ],
    [isFormDisabled, isPrimary, onEdit, onDelete],
  );

  return <ActionCellButtonCDS isDisabled={isLoading} isHidden={isFormDisabled} items={items} />;
};

RowActionButton.propTypes = {
  rowData: PropTypes.shape({
    isFormDisabled: PropTypes.bool,
    type: PropTypes.string,
    isLoading: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
  }).isRequired,
};

export default memo(RowActionButton);
